var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:currentColor;}")),React.createElement("path",{"className":"cls-1","d":"m10.48,7.62L17.04,0h-1.55l-5.69,6.62L5.24,0H0l6.88,10.01L0,18h1.55l6.01-6.99,4.8,6.99h5.24l-7.13-10.38h0Zm-2.13,2.47l-.7-1L2.11,1.17h2.39l4.47,6.4.7,1,5.82,8.32h-2.39l-4.75-6.79h0Z","key":1})]);
}

Twitter.defaultProps = {"id":"Layer_1","viewBox":"0 0 17.61 18"};

module.exports = Twitter;

Twitter.default = Twitter;
